import { Button, CardMedia, Grid, Typography } from '@mui/material'
import { Box, Container, keyframes } from '@mui/system'
import React from 'react'
// import Timeline from './Timeline'
import { Formik, Form, Field } from "formik";
import { TextField as MuiTextField } from 'formik-mui';
import * as Yup from 'yup';
import { alertMsg } from '../../utils/basicUtils';
import { Link, useNavigate } from 'react-router-dom';
import { authActions } from '../../redux/reducers/auth-slice';
import { useDispatch } from 'react-redux'
import { BRAND_NAME, REFRESH_TOKEN_EXPIRY_IN_HRS } from '../../constants';
import { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { axiosPrivate } from '../../utils/apiUtils';
import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@emotion/react'
const { sendSigninStatus } = window.electron

const pageload = keyframes`
	from {
		opacity: 0;
		transform: translateX(-100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`

const Signin = () => {
	const theme = useTheme()
	const dispatch = useDispatch()
	const navigate = useNavigate();
	const [isShowPassword, setIsShowPassword] = useState(false)
	return (
		<Box sx={{ height: { xs: "100%", md: '100vh' } }} >
			<Grid container>
				<Grid item xs={12} md={5} xl={6} >
					<Container maxWidth="sm" sx={{ mt: 5 }}>
						<Box sx={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>
							<Box >
								<CardMedia component="img" title="" sx={{ maxWidth: { xs: "60px", sm: "80px" } }} image={process.env.PUBLIC_URL + "/assets/logo.png"} />
							</Box>
							<Box sx={{ marginLeft: "10px", overflow: "hidden", }}>
								<Typography fontWeight={400} fontSize={{ xs: 28, sm: 35 }} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{BRAND_NAME}</Typography>
							</Box>
						</Box>
						<Box sx={{ mt: { xs: 10, sm: 8, xl: 20 } }}>
							<Box sx={{ mt: 4, width: { xs: "100%", sm: "90%", }, marginLeft: "auto", marginRight: "auto" }}>

								<>
									<Box textAlign={"center"}>
										<Typography variant='h1' fontWeight={400} sx={{ fontSize: { xs: "20px", md: "22px", xl: "25px" }, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Sign in to your account</Typography>
									</Box>
									<Formik
										initialValues={{
											username: '',
											password: '',
										}}
										validationSchema={
											Yup.object({
												username: Yup.string()
													.required('Username/Email is required'),
												password: Yup.string()
													.required('Password is required')
													// .matches(/^[^\s][ A-Za-z0-9_@./#&+-]+[^\s]$/, 'Password cannot contain whiteSpaces at the beginning and at the end')
													.max(12, "Password cannot exceed 12 characters")
											})
										}
										onSubmit={async (values, { setSubmitting }) => {
											try {
												const response = await axiosPrivate.post("accounts/signin/", values)
												alertMsg(response.data.message, 'success')
												const { id, email, first_name, last_name, username } = response.data.data.user;
												dispatch(authActions.grantLoginAccess({
													accessToken: response.data.data.access_token,
													user: { ...response.data.data.user },
													isLoggedIn: true
												}));
												sendSigninStatus(true)
												localStorage.clear()
												localStorage.setItem('isLoggedIn', "true")
												let currentTime = new Date()
												currentTime.setHours(currentTime.getHours() + +(REFRESH_TOKEN_EXPIRY_IN_HRS || 0))
												localStorage.setItem('lastLogIn', currentTime.getTime())
												localStorage.setItem('user', JSON.stringify({
													id,
													email,
													firstName: first_name,
													lastName: last_name,
													username
												}));
												navigate('/')
											}
											catch (error) {
												sendSigninStatus(false)
												console.error(error)
												if (error.response.data.message === 'Your account is inactive') {
													alertMsg(
														<p>
															Your account is not activated.If you want to activate your account, <a style={{ color: 'white' }} href="resend\">click Here</a>
														</p>
														, 'error'
													)
												}
											}
											setSubmitting(false);
										}}
									>
										{
											({ isSubmitting, values }) => {
												return (
													<Form>
														<Box>
															<Box sx={{ mt: 4, }}>
																<Field
																	component={MuiTextField}
																	name="username"
																	label="Email/Username"
																	fullWidth
																/>
															</Box>
															<Box sx={{ mt: 4, position: "relative" }}>
																<Field
																	component={MuiTextField}
																	name="password"
																	label="Password"
																	type={!isShowPassword ? "password" : "text"}
																	fullWidth
																	InputProps={{
																		endAdornment:
																			<InputAdornment position="end">
																				<IconButton
																					onClick={() => { setIsShowPassword(prev => !prev) }}
																					edge="end"
																				>
																					{!isShowPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
																				</IconButton>
																			</InputAdornment>
																	}}
																/>
															</Box>
														</Box>
														<Box sx={{ mt: 3, textAlign: "center" }} >
															<Typography fontSize={15} color={"primary"} variant='a' onClick={() => navigate('/accounts/forgot_password', { state: values.username })} sx={{ cursor: "pointer" }}>Forgot Password?</Typography>
														</Box>
														<Box sx={{ mt: 3, textAlign: "center" }}>
															<Button disabled={isSubmitting} size='large' variant="outlined" type="submit">Sign in</Button>
														</Box>
													</Form>
												)
											}
										}
									</Formik>
									<Box sx={{ my: 3, textAlign: "center" }}>
										<Typography sx={{ marginRight: "10px" }} fontSize={15} variant='caption'>Don't have account?</Typography>
										<Link to={"/accounts/signup"} fontSize={15} color={"primary"} style={{ textDecoration: "none" }} >Sign up</Link>
									</Box>
								</>

								{/* <Box sx={{ mt: 5, borderBottom: "1px solid #c4c4c4" }}></Box>
								<Box sx={{ mt: 5, textAlign: "center" }}>
									<Box sx={{ border: "1px solid #c4c4c4", padding: "15px", borderRadius: "4px" }}>
										<Box>
											<Grid container sx={{ alignItems: "center" }}>
												<Grid xs={1}>
													<Box>
														<img style={{ width: "30px" }} src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="" />
													</Box>
												</Grid>
												<Grid xs={11}>
													<Box>
														<Typography>Login with Google</Typography>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</Box>
								</Box> */}
							</Box>
						</Box>
					</Container>
				</Grid>
				<Grid item md={7} xl={6} sx={{ minHeight: "100vh", display: { xs: "none", md: "flex", alignItems: "center" } }} bgcolor="primary.main">
					<Box sx={{ width: "100%" }} >
						<Box sx={{ padding: { xs: "16px", lg: "32px", } }}>
							<Box sx={{ marginBottom: 4, pl: { xs: "36px", lg: "56px", } }}>
								<Typography color={"primary.contrastText"} fontWeight={400} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, fontSize: { xs: "26px", md: "30px", xl: "36px", } }}>Simple steps</Typography>
								<Typography color={"primary.contrastText"} fontWeight={400} sx={{ animation: `${pageload} 1200ms ease 500ms backwards`, fontSize: { xs: "26px", md: "30px", xl: "36px", } }}>Get your job done.</Typography>
							</Box>
							<Box sx={{ width: "85%", height: { xs: "auto", md: "300px", xl: "500px", }, borderRadius: "10px", overflow: "hidden", marginLeft: "auto", marginRight: "auto" }}>
								{/* <iframe width="100%" height="100%" src="https://www.youtube.com/embed/q3B85yvWR7c?autoplay=1&mute=1&loop=1&playlist=q3B85yvWR7c&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> */}
								<iframe width="100%" height="100%" src="https://www.youtube.com/embed/v=ta54OwYNUho?autoplay=1&mute=1&loop=1&playlist=ta54OwYNUho&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
								{/* <video width="100%" height="100%" src="https://www.youtube.com/embed/eIxwWci5Knk?autoplay=1&mute=1&loop=1&playlist=eIxwWci5Knk&controls=0"></video> */}
							</Box>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Box >
	)
}

export default Signin
